/* globals console */

    var log, isEnabled;

    log = function() {
        var args = Array.prototype.slice.call(arguments);

        args[0] = args[0] + ': %c"' + args[1] + '"';
        args[1] = 'color: #ca2117;';

        console.log.apply(console, args);
    };

    isEnabled = function(block) {
        // check global first
        if(window['logSvpPlayer' + block] === true) {
            return true;
        }

        // fix Safari errors when cookies are disabled
        try {
            if(!window.localStorage) {
                return false;
            }

            return window.localStorage.getItem('logSvpPlayer' + block);
        } catch (error) {
            return false;
        }
    };

    export default function(block) {
        if(isEnabled(block)) {
            return {
                log: function() {
                    var args = Array.prototype.slice.call(arguments);

                    if(typeof args[0] === 'function') {
                        args[0](log.bind(this, block));
                    } else {
                        args.unshift(block);
                        log.apply(this, args);
                    }
                }
            };
        }

        return {
            log: function() {}
        };
    };

